import { useCallbackWithoutArguments } from "client/Hooks";
import { ReactElement } from "react";
import { ButtonBase } from "../ButtonBase/ButtonBase";
import { Icon } from "../Icon/Icon";
import styles from "./AddButton.module.less";
import { localize } from "client_legacy/ndaw/culture";

export type AddButtonProps = {
	onClick?(): void;
	trackingId?: string;
};

export const AddButton = (props: AddButtonProps): ReactElement => {
	const {
		onClick,
		trackingId
	} = props;

	const clickHandler: (() => void) | undefined = useCallbackWithoutArguments(onClick);

	return (
		<ButtonBase
			className={styles.root}
			onClick={clickHandler}
			trackingId={trackingId}
			aria-label={localize("_Add")}
		>
			<Icon
				value={{
					kind: "font",
					name: "plus"
				}}
				size="extra-extra-large"
			/>
		</ButtonBase>
	);
};
AddButton.displayName = "AddButton";